module.exports = __webpack_public_path__ + "img/ci.abe37e2d.svg";